import http from './http'
import Resource from './resource'

const path = 'admin/clients'

class Clients extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const ClientsRequest = new Clients(http)

export default ClientsRequest
